import React from "react"
import { TextArea, Input, FileInput, FormField, Error } from "@bw/forms"
import axios from "axios"
import { Field, Radio, Checkboxe } from "formik"
import * as yup from "yup"

export const displayField = field => {
  switch (field.type) {
    case "text":
    default:
      return (
        <FormField
          htmlFor={field.handle}
          title={field.display}
          style={{ margin: "25px 0", display: "block" }}
        >
          {field.instructions && field.instructions_position === "above" && (
            <small>{field.instructions}</small>
          )}
          <Field
            type={field.input_type}
            placeholder={field.display}
            name={field.handle}
            component={Input}
          />
          {field.instructions && field.instructions_position === "below" && (
            <small>{field.instructions}</small>
          )}
        </FormField>
      )

    case "number":
    case "integer":
      return (
        <label
          htmlFor={field.handle}
          style={{ margin: "25px 0", display: "block" }}
        >
          {field.instructions && field.instructions_position === "above" && (
            <small>{field.instructions}</small>
          )}
          <Field
            type="number"
            placeholder={field.display}
            name={field.handle}
            component={Input}
          />
          {field.instructions && field.instructions_position === "below" && (
            <small>{field.instructions}</small>
          )}
        </label>
      )

    case "textarea":
      return (
        <label htmlFor={field.handle} style={{ margin: "25px 0" }}>
          {field.instructions && field.instructions_position === "above" && (
            <p>
              <small>{field.instructions}</small>
            </p>
          )}
          <Field
            type={field.input_type}
            placeholder={field.display}
            name={field.handle}
            component={TextArea}
          />
          {field.instructions && field.instructions_position === "below" && (
            <small>{field.instructions}</small>
          )}
        </label>
      )

    case "checkboxes":
      const checkboxes = field.options
      return (
        <div
          key={field.handle}
          style={{ margin: "25px 0", display: "flex", gap: "15px" }}
        >
          {field.instructions && field.instructions_position === "above" && (
            <small>{field.instructions}</small>
          )}
          {Object.values(checkboxes).map((checkboxe, i) => {
            const key = Object.keys(checkboxes)[i]
            return (
              <label
                htmlFor={key}
                key={key}
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                <Field type="checkbox" id={key} name={key} value={checkboxe} />
                {checkboxe}
              </label>
            )
          })}
          {field.instructions && field.instructions_position === "below" && (
            <small>{field.instructions}</small>
          )}
        </div>
      )

    case "radio":
      const radios = field.options
      return (
        <div
          key={field.handle}
          style={{ margin: "25px 0", display: "flex", gap: "15px" }}
        >
          {field.instructions && field.instructions_position === "above" && (
            <small>{field.instructions}</small>
          )}
          {Object.values(radios).map((radio, i) => {
            const key = Object.keys(radios)[i]
            return (
              <label
                htmlFor={key}
                key={key}
                style={{ display: "flex", gap: "5px", alignItems: "center" }}
              >
                <Field type="radio" id={key} name={key} value={radio} />
                {radio}
              </label>
            )
          })}
          {field.instructions && field.instructions_position === "below" && (
            <small>{field.instructions}</small>
          )}
        </div>
      )

    case "select":
      const selects = field.options
      return (
        <FormField
          htmlFor={field.handle}
          title={field.display}
          style={{ margin: "25px 0", display: "block" }}
        >
          {field.instructions && field.instructions_position === "above" && (
            <small>{field.instructions}</small>
          )}
          <Field as="select" name={field.handle}>
            {Object.values(selects).map((option, i) => {
              const key = Object.keys(selects)[i]
              return (
                <option key={key} value={option}>
                  {option}
                </option>
              )
            })}
          </Field>
          {field.instructions && field.instructions_position === "below" && (
            <small>{field.instructions}</small>
          )}
        </FormField>
      )

    case "assets":
      return (
        <label htmlFor={field.handle} style={{ margin: "25px 0" }}>
          {field.instructions && field.instructions_position === "above" && (
            <small>{field.instructions}</small>
          )}
          <FileInput type="file" name={field.handle} />
          {field.instructions && field.instructions_position === "below" && (
            <small>{field.instructions}</small>
          )}
        </label>
      )
  }
}

export const getFormFields = handle => {
  return axios({
    method: "GET",
    url: `/api/forms/${handle}`,
  }).then(response => {
    return response.data.data.fields
  })
}

/**
 * post form data
 */
export const postFormFields = (handle, values) => {
  const dataToSend = new FormData()
  dataToSend.append("_method", "POST")
  Object.entries(values).forEach(([key, value]) => {
    return dataToSend.append(key, value)
  })

  return axios({
    method: "POST",
    url: `/!/forms/${handle}`,
    data: dataToSend,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "multipart/form-data",
      "X-Requested-With": "XMLHttpRequest",
    },
  }).then(response => {
    if (response.status !== 200) {
      throw new Error("Invalid server response")
    }
    return response
  })
}

export const getInitialValues = fields => {
  return Object.values(fields).reduce((acc, field) => {
    switch (field.type) {
      case "text":
        acc[field.handle] = ""
        break

      case "textarea":
        acc[field.handle] = ""
        break

      case "checkboxes":
        acc[field.options] = []
        break

      case "radio":
        acc[field.options] = []
        break

      case "select":
        acc[field.options] = []
        break

      default:
        acc[field.handle] = ""
        break
    }
    return acc
  }, {})
}

const fieldType = type => {
  switch (type) {
    case "text":
    case "textarea":
      return "string"

    case "number":
    case "integer":
      return "number"

    case "email":
      return "email"

    case "checkboxes":
    case "radio":
    case "select":
      return "array"

    case "assets":
    default:
      return "mixed"
  }
}

export const fieldsSchema = fields => {
  return Object.values(fields).reduce((acc, field) => {
    const isArrayType =
      field.type === ("checkboxes" || "radio" || "selecte") ? yup.string() : ""
    if (field.validate && field.validate.includes("required")) {
      acc[field.handle] = yup[fieldType(fields.type)](isArrayType).required(
        `${field.handle} is required`
      )
    } else {
      acc[field.handle] = yup[fieldType(fields.type)](isArrayType).nullable()
    }
    return acc
  }, {})
}
